import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7175
 *
 * @param {SvgIconProps} props - svg props
 */
export const LinkOffIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M17 7H13.5C13.2239 7 13 7.22386 13 7.5V8.4C13 8.67614 13.2239 8.9 13.5 8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.43 19.12 14.63 17.79 14.98L19.25 16.44C20.88 15.61 22 13.95 22 12C22 9.24 19.76 7 17 7ZM16 11.25C16 11.1119 15.8881 11 15.75 11H13.81L15.81 13C15.9149 13 16 12.9149 16 12.81V11.25ZM2.17678 4.09322C2.07915 4.19085 2.07915 4.34915 2.17678 4.44678L5.11 7.38C3.29 8.12 2 9.91 2 12C2 14.76 4.24 17 7 17H10.5C10.7761 17 11 16.7761 11 16.5V15.6C11 15.3239 10.7761 15.1 10.5 15.1H7C5.29 15.1 3.9 13.71 3.9 12C3.9 10.41 5.11 9.1 6.66 8.93L8.73 11H8.25C8.11193 11 8 11.1119 8 11.25V12.75C8 12.8881 8.11193 13 8.25 13H10.73L13 15.27V16.5C13 16.7761 13.2239 17 13.5 17H14.73L18.5632 20.8237C18.6609 20.9211 18.819 20.921 18.9166 20.8234L19.8233 19.9167C19.9209 19.8191 19.9209 19.6609 19.8233 19.5632L3.44678 3.17688C3.34915 3.0792 3.19082 3.07918 3.09317 3.17683L2.17678 4.09322Z' fill={color}/>
        </SvgIcon>
    )
}

export default LinkOffIcon
